import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [seats, setSeats] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("itl_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("itl_cart", JSON.stringify(seats));
  }, [seats]);

  const toggleSeat = (seat) => {
    setSeats((prev) => {
      const exists = prev.some((s) => s.id === seat.id);
      if (exists) return prev.filter((s) => s.id !== seat.id);
      if (prev.length >= 8) return prev;
      return [...prev, seat];
    });
  };

  const hasSeat = (id) => seats.some((s) => s.id === id);
  const clear = () => setSeats([]);
  const total = useMemo(() => seats.reduce((sum, s) => sum + (s.price || 0), 0), [seats]);

  const value = useMemo(
    () => ({ seats, toggleSeat, hasSeat, clear, total }),
    [seats, total]
  );
  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
